<template>
  <el-dialog
    class="rc-dialog"
    :title="titleName"
    :visible.sync="showAsyncModal.flag"
    width="900px"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="closeDialog"
  >
    <div class="main-content">
      <el-transfer
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入组织名称"
        v-model="value"
        :data="data"
        :props="{
          key: 'uuid',
          label: 'deptName',
        }"
        :titles="['组织名称', '已选组织']"
      >
      </el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-checkbox
        v-permission="'pubBanner:share:online'"
        class="m-l-15"
        v-model="needOnline"
        key="needOnline"
        :true-label="1"
        :false-label="0"
        >共享后直接上线
      </el-checkbox>
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { shareDeptList } from "@/api/dept";
import { bannerShare } from "@/api/banner";
export default {
  data() {
    return {
      data: [],
      value: [],
      titleName: "共享",
      needOnline: 0,
      filterMethod(query, item) {
        return item.deptName.indexOf(query) > -1;
      },
    };
  },
  props: {
    showAsyncModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
          ids: [],
        };
      },
    },
  },
  created() {
    shareDeptList().then((res) => {
      if (!res || res.code != 0) return;
      this.data = res.data;
    });
  },
  updated() {
    let doms = document.getElementsByClassName("el-checkbox__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    submit() {
      const _this = this;
      if (this.value.length === 0) {
        this.$message({
          message: "请选择要共享的学院",
          type: "warning",
        });
      } else {
        let deptList = [];
        for (let i = 0; i < _this.value.length; i++) {
          let item = _this.data.filter(function(ele) {
            return ele.uuid == _this.value[i];
          });
          deptList.push(item[0].uuid);
        }
        let params = {
          deptIds: deptList,
          uuids: this.showAsyncModal.uuids,
          needOnline: this.needOnline
        }
        bannerShare(params).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$emit("closeDialog", true);
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    clearDept() {
      this.value = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  .main-content {
    max-height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/deep/.el-transfer-panel {
  width: 277px;
}
</style>
